import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  InputLabel,
  Snackbar,
  Alert,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import SubFooter from "../Component/SubFooter";
import axios from "axios";
import config from "../config";

function EditProfile() {
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [profile, setProfile] = useState({
    username: "",
    email: "",
    password: "",
    image: "",
  });

  const auth = JSON.parse(localStorage.getItem("access_token"));
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${auth?.token}`,
    },
  };
  /* eslint-disable */
  useEffect(() => {
    axios
      .get(`${config.url}/me`, axiosConfig)
      .then((res) => {
        setProfile(res.data.data);
      })
      .catch((e) => console.log(e.response.data.data));
  }, []);

  const onSubmit = () => {
    axios
      .patch(`${config.url}/me`, profile, axiosConfig)
      .then((res) => {
        history.push("/account");
      })
      .catch((e) => {
        setMessage(e.response.data.data);
        setOpenAlert(true);
      });
  };

  const handleClose = () => {
    setOpenAlert(false);
  };

  return (
    <React.Fragment>
      <Header />
      <Grid
        container
        sx={{ marginTop: "30px", marginBottom: "30px", minHeight: "600px" }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={1} lg={4} />
        <Grid item xs={10} lg={4} style={{ textAlign: "center" }}>
          <Grid
            item
            xs={12}
            style={{ textAlign: "center", marginBottom: "30px" }}
          >
            <Typography variant="h5">Edit Profile</Typography>
          </Grid>
          <Grid item xs={12}>
            <InputLabel
              htmlFor="outlined-adornment-amount"
              style={{ textAlign: "left" }}
            >
              Username
            </InputLabel>
            <TextField
              id="outlined-basic"
              sx={{ width: "100%", paddingBottom: "20px" }}
              variant="outlined"
              size="small"
              value={profile?.username}
              onChange={(e) => {
                setProfile({ ...profile, username: e.target.value });
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <InputLabel
              htmlFor="outlined-adornment-amount"
              style={{ textAlign: "left" }}
            >
              Email Address
            </InputLabel>
            <TextField
              id="outlined-basic"
              sx={{ width: "100%", paddingBottom: "20px" }}
              variant="outlined"
              type="email"
              size="small"
              value={profile?.email}
              onChange={(e) => {
                setProfile({ ...profile, email: e.target.value });
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <InputLabel
              htmlFor="outlined-adornment-amount"
              style={{ textAlign: "left" }}
            >
              Password
            </InputLabel>
            <TextField
              id="outlined-basic"
              variant="outlined"
              type="password"
              size="small"
              sx={{ width: "100%", paddingBottom: "20px" }}
              onChange={(e) => {
                setProfile({ ...profile, password: e.target.value });
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <Typography variant="body2">
              Your personal data will be used to support your experience
              throughout this website, to manage access to your account, and for
              other purposes described in our privacy policy.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              sx={{ background: "#cc0600", marginTop: "30px" }}
              onClick={() => onSubmit()}
            >
              Update Profile
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={1} lg={4} />
        <Snackbar
          open={openAlert}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert severity="warning">{message}</Alert>
        </Snackbar>
      </Grid>
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
}

export default EditProfile;
